import { render, staticRenderFns } from "./HousingStatistics.vue?vue&type=template&id=19543a94&scoped=true&"
import script from "./HousingStatistics.vue?vue&type=script&lang=js&"
export * from "./HousingStatistics.vue?vue&type=script&lang=js&"
import style0 from "./HousingStatistics.vue?vue&type=style&index=0&id=19543a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19543a94",
  null
  
)

export default component.exports